import { render, staticRenderFns } from "./webIndex.vue?vue&type=template&id=f6d774cc&scoped=true&"
import script from "./webIndex.vue?vue&type=script&lang=js&"
export * from "./webIndex.vue?vue&type=script&lang=js&"
import style0 from "./webIndex.vue?vue&type=style&index=0&id=f6d774cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d774cc",
  null
  
)

export default component.exports